export const DoppeActionTypeContactCardViewerLang = {
    defaultTexts: {
        linkButtonText: 'Save Contact Details',
    }
}